module.exports = __webpack_public_path__ + "static/media/Saly-10.a4f29fbb.png";